import SwitchVideo from '../hooks/useVideo'
import mobileVideo from '../assets/videos/mobileDealBlack.mp4'
import desktopVideo from '../assets/videos/desktopDealBlack.mp4'
import poster from '../assets/videos/blackDealPoster.avif'
import { useTranslation } from 'react-i18next'

export default function DealBannerBlack() {
  const { t } = useTranslation()
  return (
    <section className='flex justify-center p-2 lg:p-24 bg-black w-full flex-col xl:flex-row gap-8 2xl:gap-16'>
      <div className='w-full md:w-2/3 2xl:w-2/5 shadow-md'>
        <SwitchVideo
          mobile={mobileVideo}
          desktop={desktopVideo}
          mobilePoster={poster}
          desktopPoster={poster}
        />
      </div>
      <div className='py-8 px-2 xl:w-3/5 2xl:w-3/5'>
        <div className='w-full lg:mb-0'>
          <h2 className='sm:text-4xl text-2xl text-white uppercase font-[700] sm:mb-2 flex items-center'>
            {t('dealSectionBlack.title')}
          </h2>
          <div className='h-1 w-20 bg-gradient-to-r  from-green-500 to-blue-600 rounded-full'></div>
        </div>
        <h3 className='mt-2 sm:mt-4 text-xl text-white drop-shadow-md font-normal'>
          {t('dealSectionBlack.content')}
        </h3>
      </div>
    </section>
  )
}
